import _ from 'lodash';
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import {
  ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA
} from "@/plugins/event-bus/event-bus-names";
import EventBus from "@/plugins/event-bus";
import SettlementPaymentSearch from "@/modules/settlement-payments/SettlementPaymentSearch.model";
import SettlementPaymentService from "@/modules/settlement-payments/SettlementPaymentService";
import {SETTLEMENT_PAYMENTS_TABLE_NAME} from "@/modules/constants";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new SettlementPaymentSearch(),
    extraFilters: {},
    expand: [
      'payment.currency,',
      'settlement.currency',
      'financial_export.created_by'
    ],
    toggleColumns: {
      fields: [...getDefaultTableFields(), ...differentFields],
      requiredFields: ['settlement_no'],
      defaultFields: [
        'settlement_no',
        'settlement_type',
        'sale_no',
        'customer',
        'customer_no',
        'payment_type',
        'amount',
        'method',
        'date',
      ],
    }
  }
};

let getDefaultTableFields = () => {
  return [
    {
      key: 'settlement_no',
      label: i18n.t('Settlement'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'settlement'
    }, {
      key: 'settlement_type',
      label: i18n.t('Settlement Type'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'settlement'
    }, {
      key: 'sale_no',
      label: i18n.t('Sale'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'settlement.auction'
    }, {
      key: 'customer',
      label: i18n.t('Vendor'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'settlement.customer'
    }, {
      key: 'customer_no',
      label: i18n.t('Vendor No'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'settlement.customer'
    }, {
      key: 'payment_type',
      label: i18n.t('Payment Type'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'payment'
    }, {
      key: 'amount',
      label: i18n.t('Amount'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: ''
    }, {
      key: 'method',
      label: i18n.t('Method'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'payment'
    }, {
      key: 'date',
      label: i18n.t('Date'),
      sortable: true,
      tdClass: '',
      isVisible: true,
      expand: 'payment'
    }, {
      key: 'bank_account',
      label: i18n.t('Bank Account'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'payment'
    }, {
      key: 'reference_number',
      label: i18n.t('Reference Number'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'payment'
    }, {
      key: 'description',
      label: i18n.t('Description'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'payment'
    }, {
      key: 'reconciled',
      label: i18n.t('Reconciled'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'payment'
    }, {
      key: 'comment',
      label: i18n.t('Comment'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'payment'
    },{
      key: 'batch_info',
      label: i18n.t('Batch Info.'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'payment.batch_payment'
    },
    {
      key: 'created_at',
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'payment.created_by'
    },
    {
      key: 'updated_at',
      label: i18n.t('Updated at / Updated by'),
      sortable: true,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'payment.updated_by'
    },
    {
      key: 'check_number',
      label: i18n.t('Check Number'),
      sortable: true,
      tdClass: 'check_number-col',
      isVisible: false,
      expand: 'check_number'
    },
    {
      key: 'check_status',
      label: i18n.t('Check Status'),
      sortable: false,
      tdClass: 'check_status-col',
      isVisible: false,
      expand: 'check_status'
    },
    {
      key: 'batch_id',
      label: i18n.t('BACS ID'),
      sortable: false,
      tdClass: 'batch_id-col',
      isVisible: false,
      expand: 'batch_id'
    },
    {
      key: 'payee',
      label: i18n.t('Payee'),
      sortable: false,
      tdClass: 'payee-col',
      isVisible: false,
      expand: 'payee'
    },
    {
      key: 'beneficiary_relation',
      label: i18n.t('Beneficiary'),
      sortable: true,
      tdClass: 'beneficiary_relation-col',
      isVisible: false,
      expand: 'payment.beneficiary_relation.related_customer'
    },
    {
      key: 'starting_check_number',
      label: i18n.t('Starting No.'),
      sortable: true,
      tdClass: 'starting_no-col',
      isVisible: false,
      expand: 'payment.settlement_check'
    },
    {
      key: 'actions',
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'starting_no-col',
      isVisible: false,
      expand: 'payment.settlement_check,payment.settlement_bacs,check_uuid,bacs_uuid'
    },
    {
      key: 'payment_history',
      label: i18n.t('Payment History'),
      sortable: false,
      tdClass: 'payment_history-col',
      isVisible: false,
      expand: '',
      exclude_from_export: true
    },
    {
      key: 'vendor_group_account',
      label: i18n.t('Vendor Group Account'),
      sortable: false,
      isVisible: false,
      expand: 'settlement.auction'
    },
    {
      key: 'company_name',
      label: i18n.t('Company Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement.customer'
    },
    {
      key: 'exchange_rate',
      label: i18n.t('Exchange Rate'),
      sortable: false,
      tdClass: 'exchange-rate-col',
      isVisible: false,
      expand: 'payment',
    },
    {
      key: 'branch',
      label: i18n.t('Branch'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement.branch'
    },

  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    tableSource: null,
    tableData: {
      finance: getDefaultTableData(),
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, {searchModel}) {
      commit('updateSearchModel', new SettlementPaymentSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      EventBus.$emit(ON_SETTLEMENT_PAYMENT_TABLE_GET_TABLE_DATA, {params});

      commit('updateTableLoading', true);
      const response = await SettlementPaymentService.getSettlementPayments(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${SETTLEMENT_PAYMENTS_TABLE_NAME}.${state.tableSource}`
      })

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)

      data.expand = [...new Set([...defaultExpand, ...expand])].join(',');

      return data;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => {
      state.tableData[state.tableSource].searchModel = searchModel
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
